import React from 'react';
import Head from 'next/head';

import Header from '@/components/Header';
import Footer from '@/components/Footer';
import NeedIdSelect from '@/components/CustomFlow/Windows/NeedIdSelect';
import { CATEGORY_SUBSETS } from '@/contexts/categories_subset';

export async function getStaticProps() {
  return {
    props: {
      category: CATEGORY_SUBSETS.filter((category) => category.url_slug === 'windows')[0]
    }
  };
}

const Category = (props) => (
  <div className="page-wrapper">
    <Head>
      <meta name="description" content="CallAPro - Find a Home Service Professional Near You" />
      <title>Find Home Service Pros Near You</title>
    </Head>
    <Header />
    <NeedIdSelect {...props} />
    <Footer />
  </div>
);

export default Category;
